import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    ctaSubmit: 'Next',
    no: 'No, at a different address',
    title: 'Will your company be registered at your personal address?',
    yes: 'Yes, at the same address',
  },
  fr: {
    ctaSubmit: 'Suivant',
    no: 'Non, à une adresse différente',
    title:
      'Votre société sera-t-elle située à votre adresse personnelle\u00A0?',
    yes: 'Oui, à la même adresse',
  },
} as const);
